module.exports = function() {
  return new Worker(__webpack_public_path__ + "1ad65b1e27fcdeb27016.worker.js");
};